import styled from 'styled-components';

const WarningColumnsCap = styled.div`
  margin-top: ${(props): string => props.theme.spaces.xxl};
  border: solid 0.1rem ${(props): string => props.theme.colors.heatherGray};
  border-radius: ${(props): string => props.theme.borderRadius.curvy};
  background-color: ${(props): string => props.theme.colors.pureWhite};
  border-color: ${(props): string => props.theme.colors.lqOrange};;
  border-width: 2px;
  padding: 15px;
  > svg {
    vertical-align: middle;
    margin-right: 30px;
  }
  > button {
    display: inline;
    font-weight: bold;
    margin: 0px;
    padding: 0px;
    text-decoration: underline;
  }
`;

export { WarningColumnsCap };
